import { Booking } from "../../types/booking";
import { getCleanTime } from "../../transforms/time";

export const useGetBookingConfirmedTime = (booking: Booking | undefined) => {
  return booking?.confirmed_time
    ? getCleanTime(booking.confirmed_time)
    : undefined;
};
